module.exports = __webpack_public_path__ + "static/media/m4a.61c5fe12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/m4a.svg
// module id = 1699
// module chunks = 17